import merge_image from "./../assets/images/pdftools/merge.png";
import merge_card from "../assets/images/merge.jpg";
import split_image from "./../assets/images/lit.jpg";
import compress_image from "./../assets/images/compress.png";

const IMAGES =  {
    IMAGE_MERGE:merge_image,
    CARDMERGE:merge_card,
    IMAGE_SPLIT:split_image,
    IMAGE_COMPRESS:compress_image
}

export default IMAGES